import SceButton from '../../../../../Common/CommonComponents/sceButton';
import { getLocalizedStrings } from '../../twoFactorAuthenticationStrings';
import classes from '../../twoFactorAuthContainer.scss';

function PhoneStepOne(props) {
  let strings = getLocalizedStrings('twoFactorAuthenticationStrings');
  const textMe = <span>{strings.textMe}<img className={classes.textMeCallMeImg} src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Text.svg'} alt="Text" /></span>;
  const callMe = <span>{strings.callMe}<img className={classes.textMeCallMeImg} src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Phone.svg'} alt="Phone" /></span>;
  return (
    <div className={classes.card}>   
    <div className={classes.btnsPadding}>
      <div>  <div className={["sce-center-alg", "sce-content-row", classes.verifyLogIn].join(" ")}> {strings.VerifyYourPhoneAddress}
        <div className={["sce-content-row", classes.verifyAddress].join(" ")}>  {props.userEnteredValue} </div>
      </div>
        <div className={["sce-content-row", classes.subText].join(" ")}>{strings.VerifyYourEmailAddressSubText} </div>
        <div className={["sce-content-row", classes.subText].join(" ")}>{strings.VerifyYourPhoneNumberSubText} </div>
        <div className={["sce-content-row", "row", classes.btnContainer].join(" ")}>
          <div className={['col-md-6', classes.textCallBtn].join(" ")}>
            <SceButton type='button' value={textMe} id='sms' onClick={() => props.sendCodeHandler('sms')} 
                       isDisabled={(props.disableSendCodeBtn) ? true : false}
                       buttonType={(props.disableSendCodeBtn) ? 'sceDisabled' : 'primary'} />
          </div>
          <div className={['col-md-6', classes.textCallBtn].join(" ")}>
            <SceButton type='button' value={callMe} id='call' onClick={() => props.sendCodeHandler('call')} 
                       isDisabled={(props.disableSendCodeBtn) ? true : false}
                       buttonType={(props.disableSendCodeBtn) ? 'sceDisabled' : 'primary'} />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default PhoneStepOne;